import m from "../../../../geodata/es2015/region/usa/mnHigh";
window.am4geodata_region_usa_mnHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/mnHigh.js
// module id = null
// module chunks = 